<path
    d="M26 4.34468C26 3.1491 24.434 2.55033 23.5185 3.39576L7.99448 17.8167H0L8.73434e-05 31.2365H7.43915L23.5185 45.6043C24.434 46.4497 26 45.8508 26 44.6553V4.34468Z"
    fill="white"
/>
<path
    d="M40 24.5001C40 29.5 35.5163 32 32 32C32 32 32 28.6422 32 24.5001C32 20.3578 32 17 32 17C35.5163 17 40 19.5 40 24.5001Z"
    fill="white"
/>
